import React from 'react';
import DownArrow from '../components/downArrow';

export default class HomeSecond extends React.Component {

	render(){
		return (
			<div id="home_second" className="home_second hide_overflow">
				<div className="container h-100per">
					<div className="row h-100per">
						<div className="col-sm-7 full-height-col-sm h-50per-xs">

							<div className="outer-center">
								<div className="middle-center">
									<div className="inner-center home_second_content">
										<h1>A new world of investment technology that puts you ahead of the pack</h1>
										<div className="green_line"></div>
										<p className="dark_text">
											Full stack platform for managing investment portfolios based on the wisdom of the professional crowd.


											{/*}
											We believe that an ever-changing market calls for a dynamic investment strategy.
											 <br/>
											Our portfolios undergo frequent changes, at times daily, in order to adapt to varying market conditions.
											*/}
										</p>
										</div>
									</div>
								</div>
							</div>
						<div className="col-sm-5 full-height-col-sm h-50per-xs">

							 <img className="home_second_img" alt="ipad" src={require("../../img/computer-mobile.jpg")}/>
						</div>
					</div>
				</div>
				{/*<DownArrow elementId="home_second"></DownArrow>*/}
		    </div>

		);
		//<div className="outer-center">
		//	<div className="middle-center">
		//		<div className="inner-center">

		//		</div>
		//	</div>
		//</div>
		//
	}

}



// WEBPACK FOOTER //
// ./src/js/components/HomeSecond.js